import React, { useState, useEffect } from 'react';
import { Typography, Space, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import CustomerReviews from './CustomerReviews';
import { sampleReviews1, sampleReviews2, sampleReviews3, sampleReviews4, sampleReviews5, sampleReviews6, sampleReviews7 } from '../../data/sampleReviews';
import { ReviewData } from '../../@types/review';
import { ApplicationState } from '../../store';
import { useSelector } from 'react-redux';
import { prefixAllow, prefixAllowN } from '../../helpers/prefixAllow';

const { Title, Paragraph } = Typography;

const Review: React.FC = () => {
    const [reviews, setReviews] = useState<ReviewData[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const prefix: any = useSelector((state: ApplicationState) => state.prefix.info)
    const prefixReview = [...prefixAllow, ...prefixAllowN]

    // จำลองการโหลดข้อมูลจาก API
    const loadReviews = async () => {
        setLoading(true);
        setError(false);

        try {
            // จำลอง API call delay
            await new Promise(resolve => setTimeout(resolve, 1500));

            // จำลองความน่าจะเป็นของ error (10%)
            if (Math.random() < 0.1) {
                throw new Error('Failed to fetch reviews');
            }

            switch (prefix?.prefix) {
                case 'WK89':
                    setReviews(sampleReviews1);
                    break;
                case 'CB988':
                    setReviews(sampleReviews2);
                    break;
                case 'K88':
                    setReviews(sampleReviews2);
                    break;
                case 'AT77':
                    setReviews(sampleReviews3);
                    break;
                case 'OD911':
                    setReviews(sampleReviews3);
                    break;
                case 'TH44':
                    setReviews(sampleReviews4);
                    break;
                case '1XHENG':
                    setReviews(sampleReviews5);
                    break;
                case 'NX98':
                    setReviews(sampleReviews6);
                    break;
                case 'KUB9':
                    setReviews(sampleReviews7);
                    break;
                default:
                    break;
            }
        } catch (err) {
            setError(true);
            console.error('Error loading reviews:', err);
        } finally {
            setLoading(false);
        }
    };

    // โหลดข้อมูลครั้งแรก
    useEffect(() => {
        loadReviews();
    }, []);

    const handleRetry = () => {
        loadReviews();
    };

    // const handleLoadMore = () => {
    //     // จำลองการโหลดรีวิวเพิ่มเติม
    //     const moreReviews = getRandomReviews(5);
    //     setReviews(prev => [...prev, ...moreReviews]);
    // };

    // const averageRating = getAverageRating();

    if (!prefixReview.includes(prefix?.prefix as string)) {
        return <></>
    }

    return (
        <div className="review-page">
            {/* Reviews Section */}
            <CustomerReviews
                reviews={reviews}
                title="รีวิวจากลูกค้าที่ใช้บริการ"
                autoPlay={true}
                autoPlaySpeed={2000}
                loading={loading}
                error={error}
                onRetry={handleRetry}
            />
        </div>
    );
};

export default Review;